import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import './validations/validators.js'
import './validations/signIn.js'


$("#checkAll,#checkAll2").on("change", (e) => {
	var checked = e.target.checked;
	var form = $(e.target).closest("form");

	$(form).find("input[type=checkbox]").prop("checked", checked);
});

